import { cn, isValueBlank } from "@utils";

const SIZE_CLASSNAMES = {
  sm: ["px-2", "py-0", "text-sm"],
  md: ["px-2.5", "py-0.5", "text-base"],
};

const COLOR_CLASSNAMES = {
  amaranth: ["text-amaranth-700", "bg-amaranth-500/15"],
  amber: ["text-amber-700", "bg-amber-500/15"],
  blue: ["text-blue-700", "bg-blue-500/15"],
  cyan: ["text-cyan-700", "bg-cyan-500/15"],
  emerald: ["text-emerald-700", "bg-emerald-500/15"],
  fuchsia: ["text-fuchsia-700", "bg-fuchsia-500/15"],
  gallery: ["text-gallery-700", "bg-gallery-500/15"],
  gray: ["text-gray-700", "bg-gray-500/15"],
  green: ["text-green-700", "bg-green-500/15"],
  indigo: ["text-indigo-700", "bg-indigo-500/15"],
  lime: ["text-lime-700", "bg-lime-500/15"],
  neutral: ["text-neutral-700", "bg-neutral-500/15"],
  orange: ["text-orange-700", "bg-orange-500/15"],
  pink: ["text-pink-700", "bg-pink-500/15"],
  purple: ["text-purple-700", "bg-purple-500/15"],
  red: ["text-red-700", "bg-red-500/15"],
  rose: ["text-rose-700", "bg-rose-500/15"],
  sky: ["text-sky-700", "bg-sky-500/15"],
  slate: ["text-slate-700", "bg-slate-500/15"],
  steel: ["text-steel-700", "bg-steel-500/15"],
  stone: ["text-stone-700", "bg-stone-500/15"],
  teal: ["text-teal-700", "bg-teal-500/15"],
  violet: ["text-violet-700", "bg-violet-500/15"],
  yellow: ["text-yellow-700", "bg-yellow-500/15"],
  zinc: ["text-zinc-700", "bg-zinc-500/15"],
};

const defaultProps = {
  size: "sm",
  color: "steel",
};

export default function Badge(props) {
  const {
    className,
    value,
    size,
    color,
  } = { ...defaultProps, ...props };

  if (isValueBlank(value)) return null;

  const classNames = cn(`
    inline-block
    content-center
    text-nowrap
    rounded-full
    transition-colors
    duration-300

    bg-steel-500/15
    text-steel-700
  `,
  className,
  SIZE_CLASSNAMES[size],
  COLOR_CLASSNAMES[color]
  );

  return (
    <span className={classNames}>
      {value}
    </span>
  );
}
